import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { ArrowRight, Award, Users, Heart, ShieldCheck } from 'lucide-react';
import { injectInternalLinks } from '../lib/linkInjector';

export default function OmFirmaet({ page }) {
  return (
    <>
      <SEO 
        title={page.title?.da}
        description={page.description?.da}
      />

      {/* Main Content Section */}
      <section className="pt-16 pb-20 bg-white">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-8 lg:px-12">
          
          <div className="grid lg:grid-cols-2 gap-16 items-start mb-24">
            <div>
              {/* Page Header */}
              <div className="mb-10">
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-slate-800 tracking-tight leading-[1.15] mb-6">
                  {page.title?.da}
                </h1>
                {page.subtitle?.da && (
                  <p className="text-base md:text-xl font-semibold text-[#0b4e47] leading-relaxed">
                    {page.subtitle.da}
                  </p>
                )}
              </div>

              <h2 className="text-3xl md:text-4xl font-black text-slate-800 tracking-tight leading-[1.15] mb-8">Syddansk Malerfirma v/ Mette Frank</h2>
              <div 
                className="prose md:prose-lg prose-slate max-w-none"
                dangerouslySetInnerHTML={{ __html: injectInternalLinks(page.content?.da, page.slug?.da || 'om-os') }}
              />
              
              <div className="grid grid-cols-2 gap-6 mt-12">
                <div className="flex items-center gap-4 p-4 bg-teal-900 rounded-2xl border border-teal-800">
                  <Award className="w-10 h-10 text-orange-500" />
                  <div>
                    <p className="font-bold text-white">15+ år</p>
                    <p className="text-sm text-teal-200/70">Erfaring</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-teal-900 rounded-2xl border border-teal-800">
                  <Heart className="w-10 h-10 text-orange-500" />
                  <div>
                    <p className="font-bold text-white">Kvalitet</p>
                    <p className="text-sm text-teal-200/70">I fokus</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/img-6919.jpeg" 
                alt="Medalje for kvalitet" 
                className="w-full rounded-3xl shadow-2xl relative z-10"
              />
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-900/10 rounded-full blur-3xl -z-0"></div>
              <div className="absolute -top-6 -left-6 w-48 h-48 bg-orange-500/10 rounded-full blur-3xl -z-0"></div>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-teal-900 p-6 sm:p-10 sm:rounded-3xl -mx-6 sm:mx-0 border-y sm:border border-teal-800">
              <ShieldCheck className="w-12 h-12 text-orange-500 mb-6" />
              <h3 className="text-2xl font-extrabold text-white mb-4 tracking-tight leading-snug">Bæredygtigt malerarbejde</h3>
              <p className="text-teal-100/80 leading-relaxed">
                Vi har et bæredygtigt fokus, og det vil du opleve som værende et gennemgående træk ved alle aspekter af malerarbejdet. Det arbejde vi leverer, er altid af høj kvalitet og derfor holder det mange år frem.
              </p>
            </div>
            <div className="bg-teal-900 p-6 sm:p-10 sm:rounded-3xl -mx-6 sm:mx-0 border-y sm:border border-teal-800">
              <Users className="w-12 h-12 text-orange-500 mb-6" />
              <h3 className="text-2xl font-extrabold text-white mb-4 tracking-tight leading-snug">Kundetilfredshed</h3>
              <p className="text-teal-100/80 leading-relaxed">
                Uanset opgavens størrelse løser vi den med fokus på at indfri dine forventninger og vi afslutter ikke en opgave før du er tilfreds og før vi som fagfolk kan være stolte af malerarbejdet.
              </p>
            </div>
            <div className="bg-stone-900 p-6 sm:p-10 sm:rounded-3xl text-white shadow-xl -mx-6 sm:mx-0">
              <h3 className="text-2xl font-extrabold mb-4 tracking-tight leading-snug">Skånsomme produkter</h3>
              <p className="text-slate-300 leading-relaxed">
                Derudover benytter vi os kun af skånsomme kvalitetsprodukter og -maling, der er indeklima-forbedrende og gør mindst mulig skade på miljøet.
              </p>
              <div className="mt-8">
                <Link to="/kontakt" className="inline-flex items-center gap-2 text-orange-500 font-bold hover:text-white transition-colors">
                  Kontakt os for rådgivning <ArrowRight className="w-5 h-5" />
                </Link>
              </div>
            </div>
          </div>




        </div>
      </section>

    </>
  );
}
